/* global axios */
import ApiClient from './ApiClient';

class WhatsappFlowsAPI extends ApiClient {
  constructor() {
    super('whatsapp_flows', { accountScoped: true });
  }

  // Flow CRUD
  getFlows() {
    return axios.get(this.url);
  }

  getFlow(flowId) {
    return axios.get(`${this.url}/${flowId}`);
  }

  createFlow(flowData) {
    return axios.post(this.url, { whatsapp_flow: flowData });
  }

  updateFlow(flowId, flowData) {
    return axios.patch(`${this.url}/${flowId}`, { whatsapp_flow: flowData });
  }

  deleteFlow(flowId) {
    return axios.delete(`${this.url}/${flowId}`);
  }

  // Flow Actions
  activateFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/activate`);
  }

  pauseFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/pause`);
  }

  archiveFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/archive`);
  }

  unarchiveFlow(flowId) {
    return axios.post(`${this.url}/${flowId}/unarchive`);
  }

  // Flow Steps
  getSteps(flowId) {
    return axios.get(`${this.url}/${flowId}/whatsapp_flow_steps`);
  }

  createStep(flowId, stepData) {
    return axios.post(`${this.url}/${flowId}/whatsapp_flow_steps`, {
      whatsapp_flow_step: stepData,
    });
  }

  updateStep(flowId, stepId, stepData) {
    return axios.patch(`${this.url}/${flowId}/whatsapp_flow_steps/${stepId}`, {
      whatsapp_flow_step: stepData,
    });
  }

  deleteStep(flowId, stepId) {
    return axios.delete(`${this.url}/${flowId}/whatsapp_flow_steps/${stepId}`);
  }

  moveStepUp(flowId, stepId) {
    return axios.post(
      `${this.url}/${flowId}/whatsapp_flow_steps/${stepId}/move_up`
    );
  }

  moveStepDown(flowId, stepId) {
    return axios.post(
      `${this.url}/${flowId}/whatsapp_flow_steps/${stepId}/move_down`
    );
  }

  // Enrollments
  getEnrollments(flowId, params = {}) {
    return axios.get(`${this.url}/${flowId}/whatsapp_flow_enrollments`, {
      params,
    });
  }

  createEnrollment(flowId, contactId, enrollmentData = {}) {
    return axios.post(`${this.url}/${flowId}/whatsapp_flow_enrollments`, {
      contact_id: contactId,
      enrollment_data: enrollmentData,
    });
  }

  pauseEnrollment(flowId, enrollmentId) {
    return axios.post(
      `${this.url}/${flowId}/whatsapp_flow_enrollments/${enrollmentId}/pause`
    );
  }

  resumeEnrollment(flowId, enrollmentId) {
    return axios.post(
      `${this.url}/${flowId}/whatsapp_flow_enrollments/${enrollmentId}/resume`
    );
  }

  cancelEnrollment(flowId, enrollmentId) {
    return axios.post(
      `${this.url}/${flowId}/whatsapp_flow_enrollments/${enrollmentId}/cancel`
    );
  }

  enrollByLabel(flowId, label, enrollmentData = {}) {
    return axios.post(
      `${this.url}/${flowId}/whatsapp_flow_enrollments/enroll_by_label`,
      { label, enrollment_data: enrollmentData }
    );
  }

  enrollByLabelStatus(flowId, jobId) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_enrollments/enroll_by_label_status`,
      { params: { job_id: jobId } }
    );
  }

  // Reports & Analytics
  getSummary(flowId) {
    return axios.get(`${this.url}/${flowId}/whatsapp_flow_reports/summary`);
  }

  getEnrollmentTimeline(flowId, params = {}) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_reports/enrollment_timeline`,
      { params }
    );
  }

  getStatusDistribution(flowId) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_reports/status_distribution`
    );
  }

  getCancelledContacts(flowId, params = {}) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_reports/cancelled_contacts`,
      { params }
    );
  }

  getMessageAnalytics(flowId) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_reports/message_analytics`
    );
  }

  // Export
  exportEnrollments(flowId, params = {}) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_reports/export_enrollments`,
      {
        params,
        responseType: 'blob',
      }
    );
  }

  exportSummary(flowId, params = {}) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_reports/export_summary`,
      { params }
    );
  }

  exportReport(flowId, reportType, params = {}) {
    return axios.get(
      `${this.url}/${flowId}/whatsapp_flow_reports/${reportType}`,
      {
        params: { ...params, format: 'csv' },
        responseType: 'blob',
      }
    );
  }
}

export default new WhatsappFlowsAPI();
